<template>
  <l-table
    ref="LTable"
    :module-name="MODULE_USER"
    :table-columns="tableColumns"
  >
    <template #create-body>
      <create @refetchData="refetchData" />
    </template>
    <template #cell(org_id)="{ data }">
      <p :title=" data.value ? $langName(data.value.name) : $t('None')">
        {{ data.value ? $langName(data.value.short_name) : $t('None') }}
      </p>
    </template>
    <template #cell(user_type)="{ data }">
      {{ get_user_type(data.value) }}
    </template>
    <template #cell(role_id)="{ data }">
      {{ get_role(data.value) }}
    </template>

    <!-- Column: Actions -->
    <template #cell(actions)="{ data }">

      <div class="text-nowrap">
        <feather-icon
          v-if="$can('update', 'All')"
          :id="`invoice-row-${data.item.id}-send-icon`"
          v-b-toggle.sidebar-create-user
          icon="EditIcon"
          class="mr-1 cursor-pointer"
          size="16"
          @click="update(data.item)"
        />
        <feather-icon
          :id="`invoice-row-${data.item.id}-preview-icon`"
          icon="EyeIcon"
          size="16"
          class="mr-1 cursor-pointer"
          @click="$router.push({ name: 'user', params: { id: data.item.id }})"
        />
        <b-tooltip
          title="Ko'rish"
          :target="`invoice-row-${data.item.id}-preview-icon`"
        />
      </div>
    </template>
  </l-table>
  <!-- Table Container Card -->

</template>

<script>
import {
  BButton, BTooltip, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import config from './config'
import userModule from '@/store/user/index'
import organizationModule from '@/store/organization/index'
import i18n from '@/libs/i18n'
import LTable from '@/views/components/LTable.vue'
import Create from './UserListAddNew.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    LTable,
    // eslint-disable-next-line vue/no-unused-components
    BButton,
    BTooltip,
    Create,
  },
  created() {
    this.$store.commit('user/FRESH')
    this.$store.dispatch('organization/list', { limit: 9999 })
    this.$store.dispatch('staticModule/role')
  },
  methods: {
    get_role(role) {
      const roles1 = this.$store.state.staticModule.roles
      // eslint-disable-next-line no-restricted-syntax
      for (const i in roles1) {
        if (role === roles1[i].id) return roles1[i].name[i18n.locale]
      }
      return 'None'
    },
    has_electronic_key: isYes => {
      let eds
      if (isYes) {
        switch (i18n.locale) {
          case 'uz':
            eds = 'ERI bor'
            break
          case 'ru':
            eds = 'Есть ЭРИ'
            break
          case 'en':
            eds = 'Have eds'
            break
          default:
            eds = 'None'
        }
        return eds
      }
      return 'None'
    },
    get_user_type: type => {
      let typeUser
      if (type === 'F') {
        switch (i18n.locale) {
          case 'uz':
            typeUser = 'Xorijiy'
            break
          case 'ru':
            typeUser = 'Иностранный'
            break
          case 'en':
            typeUser = 'Foreign'
            break
          default:
            typeUser = 'None'
        }
        return typeUser
      }
      if (type === 'I') {
        switch (i18n.locale) {
          case 'uz':
            typeUser = 'Jismoniy'
            break
          case 'ru':
            typeUser = 'Физический'
            break
          case 'en':
            typeUser = 'Physical'
            break
          default:
            typeUser = 'None'
        }
        return typeUser
      }
      if (type === 'L') {
        switch (i18n.locale) {
          case 'uz':
            typeUser = 'Yuridik shahs'
            break
          case 'ru':
            typeUser = 'Юридическое лицо'
            break
          case 'en':
            typeUser = 'Legal entity'
            break
          default:
            typeUser = 'None'
        }
        return typeUser
      }
      return 'None'
    },
    // eslint-disable-next-line consistent-return
    get_org_name(orgId) {
      const lang = this.$i18n.locale
      const orgs = this.$store.state.organization.organizations
      // eslint-disable-next-line no-restricted-syntax
      for (const x of orgs) {
        if (x.id === orgId) {
          return x.name[lang]
        }
      }
      return 'None'
    },
    update(data) {
      this.$store.commit('user/UPDATE', data)
    },
  },
  setup() {
    const MODULE_USER = 'user'
    const MODULE_ORGANIZATION = 'organization'
    // Register module
    if (!store.hasModule(MODULE_USER)) store.registerModule(MODULE_USER, userModule)
    if (!store.hasModule(MODULE_ORGANIZATION)) store.registerModule(MODULE_ORGANIZATION, organizationModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_USER)) store.unregisterModule(MODULE_USER)
      if (store.hasModule(MODULE_ORGANIZATION)) store.unregisterModule(MODULE_ORGANIZATION)
    })

    return {
      ...config(),
      MODULE_USER,
      MODULE_ORGANIZATION,
    }
  },
}
</script>
